import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header, Footer, Sidebar } from '../components';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  
  // Define routes that should not have header, footer, and sidebar
  const authRoutes = [
    '/signup',
    '/login',
    '/otp-verification',
    '/forgot-password',
    '/reset-password'
  ];
  
  const isAuthRoute = authRoutes.includes(location.pathname);
  
  if (isAuthRoute) {
    // Render only the children for auth pages
    return (
      <div className="auth-layout">
        <main className="auth-main">
          {children}
        </main>
      </div>
    );
  }
  
  // Render full layout for other pages
  return (
    <div className="main-layout">
      <Header />
      <div className="app-content">
        <Sidebar />
        <main className="main-content">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
